export enum UiNotificationType {
    Default,
    Success = 'Success',
    Info = 'Info',
    Warning = 'Warning',
    Error = 'Error',
}
